import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import NotifichePopover from "./NotifichePopover";
import RicercaGlobale from "./RicercaGlobale";
import api from "../lib/api";
import {
  SquaresFour,
  ClipboardText,
  UsersThree,
  CalendarBlank,
  Receipt,
  FolderSimple,
  Sparkle,
  SignOut,
  Compass,
  Ruler,
  Buildings,
  PaintBrush,
  UsersFour,
  UserGear,
  CurrencyEur,
  Gear,
  FileText,
  BookOpen,
  Calculator,
  Sun,
  Moon,
  ShieldCheck,
  Camera,
  List as ListIcon,
  X,
  HardHat,
  Wallet,
  IdentificationBadge,
  Ruler as RulerIcon,
  Truck,
  BuildingApartment,
  AddressBook,
  MagnifyingGlass,
  CreditCard,
} from "@phosphor-icons/react";
import AvvisoAbbonamento from "./abbonamento/AvvisoAbbonamento";
import AssistenteFloating from "./AssistenteFloating";
import { NuovoGlobale } from "./NuovoGlobale";

const dashboardItem = { to: "/dashboard", label: "Dashboard", icon: SquaresFour, testid: "nav-dashboard" };
const dashboardImpresa = { to: "/impresa", label: "Dashboard Impresa", icon: SquaresFour, testid: "nav-impresa-dashboard" };

const navGroupsImpresa = [
  {
    label: "Ogni giorno",
    items: [
      { to: "/calendario?filtro=impresa", label: "Scadenze e calendario", icon: CalendarBlank, testid: "nav-impresa-scadenzario", prefix: "/impresa/scadenzario", prefix2: "/calendario" },
      { to: "/impresa/movimenti", label: "Contabilità", icon: Wallet, testid: "nav-impresa-documenti-mov", prefix: "/impresa/movimenti" },
      { to: "/impresa/cantieri", label: "Cantieri", icon: Buildings, testid: "nav-impresa-cantieri" },
      { to: "/impresa/cantiere-mode", label: "Modalità cantiere", icon: HardHat, testid: "nav-impresa-cantiere-mode" },
      { to: "/impresa/operai", label: "Operai", icon: IdentificationBadge, testid: "nav-impresa-operai", prefix: "/impresa/operai" },
      { to: "/impresa/fornitori", label: "Fornitori e Clienti", icon: AddressBook, testid: "nav-impresa-fornitori" },
    ],
  },
  {
    label: "Gestione",
    items: [
      { to: "/impresa/preventivi", label: "Preventivi & Rendiconti", icon: FileText, testid: "nav-impresa-preventivi" },
      { to: "/impresa/patrimonio", label: "Patrimonio", icon: Truck, testid: "nav-impresa-patrimonio" },
      { to: "/clienti", label: "Anagrafica Clienti", icon: UsersThree, testid: "nav-impresa-clienti" },
    ],
  },
  {
    label: "Archivio e impostazioni",
    items: [
      { to: "/documenti", label: "Archivio Documenti", icon: FolderSimple, testid: "nav-impresa-documenti", prefix2: "/letture-ai" },
      { to: "/impresa/profilo", label: "Impostazioni impresa", icon: Gear, testid: "nav-impresa-profilo" },
      { to: "/abbonamento", label: "Abbonamento", icon: CreditCard, testid: "nav-impresa-abbonamento" },
    ],
  },
];

const navGroups = [
  {
    label: "Ogni giorno",
    items: [
      { to: "/pratiche", label: "Incarichi", icon: ClipboardText, testid: "nav-pratiche" },
      { to: "/calendario", label: "Calendario", icon: CalendarBlank, testid: "nav-calendario" },
      { to: "/clienti", label: "Clienti", icon: UsersThree, testid: "nav-clienti" },
      { to: "/preventivi", label: "Preventivi & Avvisi", icon: Receipt, testid: "nav-preventivi", prefix2: "/fatturazione" },
      { to: "/documenti", label: "Documenti", icon: FolderSimple, testid: "nav-documenti", prefix2: "/letture-ai" },
    ],
  },
  {
    label: "Lavoro",
    items: [
      { to: "/verbale-rapido", label: "Verbale rapido", icon: Camera, testid: "nav-verbale-rapido" },
      { to: "/computi-metrici", label: "Preventivi & Rendiconti", icon: Calculator, testid: "nav-computi" },
      { to: "/condomini", label: "Amministrazione Condomini", icon: BuildingApartment, testid: "nav-condomini" },
      { to: "/assistente", label: "Assistente AI", icon: Sparkle, testid: "nav-assistente" },
    ],
  },
  {
    label: "Soggetti",
    items: [
      { to: "/imprese", label: "Imprese", icon: Buildings, testid: "nav-imprese" },
      { to: "/tecnici", label: "Tecnici colleghi", icon: UserGear, testid: "nav-tecnici" },
    ],
  },
  {
    label: "Documenti & Normativa",
    items: [
      { to: "/template-documenti", label: "Template Documenti", icon: FileText, testid: "nav-template-documenti" },
      { to: "/modulistica-normativa", label: "Modulistica & Normativa", icon: BookOpen, testid: "nav-modulistica-normativa" },
    ],
  },
  {
    label: "Configurazione",
    items: [
      { to: "/impostazioni", label: "Tipi Incarico", icon: Gear, testid: "nav-impostazioni" },
      { to: "/profilo-studio", label: "Profilo Studio", icon: Buildings, testid: "nav-profilo-studio" },
      { to: "/profilo", label: "Profilo Personale", icon: UserGear, testid: "nav-profilo" },
      { to: "/backup", label: "Backup", icon: ShieldCheck, testid: "nav-backup" },
      { to: "/abbonamento", label: "Abbonamento", icon: CreditCard, testid: "nav-abbonamento" },
    ],
  },
];

const QUALIFICA_META = {
  geometra: { label: "Geometra", icon: Ruler },
  ingegnere: { label: "Ingegnere", icon: Compass },
  architetto: { label: "Architetto", icon: Buildings },
  designer: { label: "Interior Designer", icon: PaintBrush },
};

/** "GEOMETRA ALESJO SINANI" → "Geometra Alesjo Sinani" (solo per la visualizzazione; sigle come SRL, P.IVA restano). */
const titolo = (s) => String(s || "").split(" ").map((w) => (/^(SRL|SRLS|SNC|SAS|SPA|P\.IVA|CF|SS)$/i.test(w) ? w.toUpperCase() : w.length > 1 && w === w.toUpperCase() ? w.charAt(0) + w.slice(1).toLowerCase() : w)).join(" ");

export default function Layout() {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();
  const [studio, setStudio] = useState(null);
  const [menuAperto, setMenuAperto] = useState(false);
  const [ricercaAperta, setRicercaAperta] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setRicercaAperta(true); } };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  const location = useLocation();

  useEffect(() => { setMenuAperto(false); }, [location.pathname]);

  const inImpresa = location.pathname.startsWith("/impresa");
  const [scadBadge, setScadBadge] = useState(null);
  useEffect(() => {
    if (!inImpresa && localStorage.getItem("gromapp.ambito") !== "impresa") return undefined;
    const load = () => api.get("/impresa/scadenzario/conteggio?giorni=30", { cache: false }).then((r) => setScadBadge(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [inImpresa]);
  const [ambito, setAmbito] = useState(() => localStorage.getItem("gromapp.ambito") || "impresa");
  useEffect(() => {
    const soloStudio = ["/dashboard", "/pratiche", "/verbale-rapido", "/fatturazione", "/computi-metrici", "/condomini", "/assistente", "/studio", "/compensi", "/profilo-studio", "/preventivi", "/modulistica-normativa", "/template-documenti", "/scadenze-professionali", "/imprese", "/tecnici"];
    const a = inImpresa ? "impresa" : (soloStudio.some((r) => location.pathname === r || location.pathname.startsWith(r + "/")) ? "studio" : null);
    if (a && a !== ambito) { setAmbito(a); localStorage.setItem("gromapp.ambito", a); }
  }, [inImpresa, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  const cambiaAmbito = (a) => {
    setAmbito(a); localStorage.setItem("gromapp.ambito", a);
    navigate(a === "impresa" ? "/impresa" : "/dashboard");
  };
  const gruppi = ambito === "impresa" ? navGroupsImpresa : navGroups;
  const attivo = (it) => (it.prefix2 && location.pathname.startsWith(it.prefix2)) || (it.prefix ? location.pathname.startsWith(it.prefix) : it.to.includes("?") ? location.pathname + location.search === it.to : location.pathname === it.to || location.pathname.startsWith(it.to + "/"));
  const dash = ambito === "impresa" ? dashboardImpresa : dashboardItem;

  useEffect(() => {
    let mounted = true;
    api.get("/studio/me").then(({ data }) => { if (mounted) setStudio(data); }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const qualifica = user?.qualifica || "geometra";
  const qm = QUALIFICA_META[qualifica] || QUALIFICA_META.geometra;
  const QIcon = qm.icon;
  const initials = (user?.name || "U")
    .split(" ")
    .map((s) => s.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* Velo per il menu su telefono */}
      {menuAperto && (
        <button
          type="button"
          aria-label="Chiudi menu"
          onClick={() => setMenuAperto(false)}
          className="lg:hidden fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-sm"
          data-testid="sidebar-overlay"
        />
      )}

      {/* Sidebar: fissa da desktop, a scomparsa su telefono */}
      <aside
        className={`w-72 bg-white border-r border-slate-200 flex-shrink-0 flex flex-col
          max-lg:fixed max-lg:inset-y-0 max-lg:left-0 max-lg:z-50 max-lg:overflow-y-auto max-lg:shadow-2xl
          max-lg:transition-transform max-lg:duration-200 ${menuAperto ? "max-lg:translate-x-0" : "max-lg:-translate-x-full"}`}
        data-testid="sidebar"
      >
        <button
          type="button"
          onClick={() => setMenuAperto(false)}
          className="lg:hidden absolute top-3 right-3 z-10 h-8 w-8 rounded-md bg-white/90 text-slate-900 flex items-center justify-center shadow"
          data-testid="sidebar-close"
          aria-label="Chiudi menu"
        >
          <X size={16} weight="bold" />
        </button>
        {/* Studio header */}
        <div className="relative border-b border-slate-200 overflow-hidden">
          {/* Decorative gradient background */}
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
          <div className="absolute inset-0 opacity-[0.06]" style={{
            backgroundImage: "radial-gradient(circle at 20% 30%, #fff 1px, transparent 1px), radial-gradient(circle at 70% 60%, #fff 1px, transparent 1px)",
            backgroundSize: "24px 24px, 32px 32px",
          }} />

          <div className="relative p-4" data-sidebar-dark>
            {/* Intestazione studio (senza logo, testo in maiuscolo/minuscolo normale) */}
            <div className="min-w-0 mb-4">
              <div className="font-semibold text-sm text-white leading-tight truncate" data-testid="sidebar-studio-line1">
                {titolo(studio?.intestazione_riga1 || studio?.nome || "Studio Tecnico")}
              </div>
              <div className="mt-0.5 text-xs text-slate-300 truncate" data-testid="sidebar-studio-line2">
                {titolo(studio?.intestazione_riga2 || (studio?.citta ? `${studio.citta}${studio.provincia ? ` · ${studio.provincia}` : ""}` : "Gestionale"))}
              </div>
              {studio?.partita_iva && (
                <div className="mt-0.5 text-xs text-slate-400 truncate">P.IVA {studio.partita_iva}</div>
              )}
            </div>

            {/* Tecnico card (name + qualifica) */}
            <div className="rounded-lg bg-white/95 backdrop-blur border border-white/20 shadow-lg p-3 relative" data-testid="tecnico-card">
              <div className="absolute top-1.5 right-1.5">
                <NotifichePopover />
              </div>
              <div className="flex items-center gap-3">
                <div className="h-11 w-11 rounded-lg bg-gradient-to-br from-slate-800 to-slate-900 text-white flex items-center justify-center flex-shrink-0 shadow-md ring-2 ring-white overflow-hidden">
                  {user?.picture ? (
                    <img src={user.picture} alt={user?.name || "Tecnico"} className="h-full w-full object-cover" referrerPolicy="no-referrer" data-testid="tecnico-avatar" />
                  ) : (
                    <span className="font-heading font-bold text-sm" data-testid="tecnico-initials">{initials}</span>
                  )}
                </div>
                <div className="min-w-0 flex-1 pr-5">
                  <div className="text-[9px] font-mono uppercase tracking-widest text-slate-500 leading-none mb-0.5">Tecnico</div>
                  <div className="font-heading font-bold text-sm text-slate-900 truncate leading-tight" data-testid="tecnico-name">
                    {user?.name || "Utente"}
                  </div>
                  <div className="mt-1 inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-slate-900 text-white" data-testid="tecnico-qualifica">
                    <QIcon size={10} weight="fill" className="text-amber-300" />
                    <span className="text-[9px] font-semibold uppercase tracking-wider">{qm.label}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <nav className="p-3">
          <div className="grid grid-cols-2 gap-1 p-1 rounded-lg bg-slate-100 mb-3" data-testid="ambito-switch">
            <button type="button" onClick={() => cambiaAmbito("impresa")} data-testid="ambito-impresa"
              className={`flex items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-semibold transition-colors ${ambito === "impresa" ? "bg-[#0B1F3A] text-white shadow" : "text-slate-600 hover:text-slate-900"}`}>
              <HardHat size={14} /> Impresa
            </button>
            <button type="button" onClick={() => cambiaAmbito("studio")} data-testid="ambito-studio"
              className={`flex items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-semibold transition-colors ${ambito === "studio" ? "bg-slate-900 text-white shadow" : "text-slate-600 hover:text-slate-900"}`}>
              <RulerIcon size={14} /> Studio
            </button>
          </div>
          {/* Dashboard standalone */}
          <NavLink
            to={dash.to}
            data-testid={dash.testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${
                isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              }`
            }
          >
            <dash.icon size={18} weight="regular" />
            <span>{dash.label}</span>
          </NavLink>

          {gruppi.map((group) => (
            <div key={group.label} className="pt-4 mt-3 border-t border-slate-100">
              <div className="px-3 pb-1.5 text-[10px] font-mono uppercase tracking-widest text-slate-400">{group.label}</div>
              <div className="space-y-0.5">
                {group.items.map((it) => { const { to, label, icon: Icon, testid } = it; return (
                  <NavLink
                    key={to}
                    to={to}
                    data-testid={testid}
                    className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${attivo(it) ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"}`}
                  >
                    <Icon size={18} weight="regular" />
                    <span className="flex-1">{label}</span>
                    {testid === "nav-impresa-scadenzario" && scadBadge?.totale > 0 && (
                      <span className={`ml-auto inline-flex items-center justify-center min-w-[22px] h-5 px-1.5 rounded-full text-[10px] font-bold font-mono ${scadBadge.scaduti > 0 ? "bg-red-600 text-white" : "bg-amber-400 text-slate-900"}`} title={`${scadBadge.totale} scadenze nei prossimi 30 giorni · ${scadBadge.scaduti} già scadute`} data-testid="nav-scadenze-badge">{scadBadge.totale > 99 ? "99+" : scadBadge.totale}</span>
                    )}
                  </NavLink>
                ); })}
              </div>
            </div>
          ))}
        </nav>

        <div className="p-3 border-t border-slate-200 mt-3">
          {/* Email account */}
          <div className="px-3 py-1.5">
            <div className="text-[10px] text-slate-400 font-mono uppercase tracking-widest truncate" data-testid="sidebar-email">{user?.email}</div>
          </div>

          {/* Tema interfaccia */}
          <div className="px-3 py-1.5">
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-400 mb-1.5">Tema interfaccia</div>
            <div className="flex items-center gap-1 bg-slate-50 border border-slate-200 rounded-md p-1" data-testid="sidebar-theme-toggle">
              <button
                type="button"
                onClick={() => setTheme("light")}
                data-testid="sidebar-theme-light"
                className={`flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 rounded text-xs font-medium transition-colors ${theme === "light" ? "bg-white text-slate-900 shadow-sm border border-slate-200" : "text-slate-500 hover:text-slate-900"}`}
              >
                <Sun size={14} weight={theme === "light" ? "fill" : "regular"} className={theme === "light" ? "text-amber-500" : ""} />
                Chiaro
              </button>
              <button
                type="button"
                onClick={() => setTheme("dark")}
                data-testid="sidebar-theme-dark"
                className={`flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 rounded text-xs font-medium transition-colors ${theme === "dark" ? "bg-slate-900 text-white shadow-sm" : "text-slate-500 hover:text-slate-900"}`}
              >
                <Moon size={14} weight={theme === "dark" ? "fill" : "regular"} className={theme === "dark" ? "text-blue-300" : ""} />
                Scuro
              </button>
            </div>
          </div>

          {/* Esci */}
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-3 px-3 py-2 mt-1 rounded-md text-sm text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
          >
            <SignOut size={18} weight="regular" />
            <span>Esci</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 flex flex-col min-w-0">
        {/* Top bar with global search */}
        <div className="sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-slate-200">
          <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 flex items-center gap-3 min-w-0">
            <button
              type="button"
              onClick={() => setMenuAperto(true)}
              className="lg:hidden h-9 w-9 rounded-md border border-slate-200 bg-white text-slate-700 flex items-center justify-center flex-shrink-0"
              data-testid="sidebar-open"
              aria-label="Apri menu"
            >
              <ListIcon size={18} weight="bold" />
            </button>
            <button type="button" onClick={() => setRicercaAperta(true)} className="flex-1 min-w-0 max-w-xl h-9 flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-500 hover:border-slate-400 text-left" data-testid="ricerca-apri">
              <MagnifyingGlass size={16} className="shrink-0" /> <span className="flex-1 min-w-0 truncate"><span className="sm:hidden">Cerca…</span><span className="hidden sm:inline">Cerca ovunque: cliente, cantiere, fattura, incarico…</span></span>
              <kbd className="hidden md:inline text-xs font-mono border border-slate-200 rounded px-1.5 text-slate-400">Ctrl K</kbd>
            </button>
            <RicercaGlobale open={ricercaAperta} onOpenChange={setRicercaAperta} ambito={ambito} pagine={[dash, ...gruppi.flatMap((g) => g.items), ...(ambito === "impresa" ? [dashboardItem, ...navGroups] : [dashboardImpresa, ...navGroupsImpresa]).flatMap((g) => g.items || [g])]} />
            <NuovoGlobale ambito={ambito} />
          </div>
        </div>
        <AvvisoAbbonamento />
        {location.pathname.startsWith("/impresa") ? <div className="p-4 md:p-8 w-full max-w-[1400px] mx-auto" data-testid="impresa-page"><Outlet /></div> : <Outlet />}
      </main>
      <AssistenteFloating />
      <NuovoGlobale ambito={ambito} variante="fab" />
    </div>
  );
}
